import React from 'react';
import styles from './InsufficientBalance.module.css';
import InsufficientBalance from './InsufficientBalance';
import {
    Drawer,
    DrawerContent,
} from '../ui/drawer';
import usePlayerBalance from '@/src/hooks/data/usePlayerBalance';
import { 
  useGameDefinition,
  useShowInsufficientBalance
} from '@/src/hooks/data/useGameTable';
import { hideInsufficientBalance } from '@/Poker/redux/slices/gameTableSlice';
import { useDispatch } from 'react-redux';
import useGameConnection from '@/src/hooks/data/useGameConnection';

export default function InsufficientBalanceDrawer({
    tempTableId
}) {
    const dispatch = useDispatch();
    const { totalBalance } = usePlayerBalance();
    const gameDefinition = useGameDefinition(tempTableId);
    const minBuyInAmount = gameDefinition?.minBuyInAmount;
    const showInsufficientBalance = useShowInsufficientBalance(tempTableId);
    const { connected } = useGameConnection(tempTableId);

    const handleOutsideClick = () => {
        dispatch(hideInsufficientBalance({ tempTableId }));
    };

    return (
        <Drawer dismissible={false} open={showInsufficientBalance && connected}>
            <DrawerContent draggable={false} onInteractOutside={handleOutsideClick} className={styles.drawerContent}>
                <InsufficientBalance
                    totalBalance={totalBalance}
                    minBuyInAmount={minBuyInAmount}
                    tempTableId={tempTableId}
                    handleCloseMark={handleOutsideClick}
                />
            </DrawerContent>
        </Drawer>
    );
}